import React from "react";
import { Modal, Tag, Button, Row, Col, Divider } from "antd";
import { useSelector } from "react-redux";
import { formatDateToDMY, formatTime12Hour, formatEventType } from "../../utils/tools";

const ReadingPlanViewModal = ({ open, onClose, data, onStatusChange }) => {
    const viewPermissions = useSelector((state) => state.permission.rolePermissions) || [];
    if (!data) return null;
    console.log(data)

    const getStatusColor = (status) => {
        switch (status) {
            case "accepted":
                return "green";
            case "rejected":
                return "red";
            case "new":
            default:
                return "blue";
        }
    };

    const Item = ({ label, value }) => (
        <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 13, color: "#888", fontWeight: 500 }}>
                {label}
            </div>
            <div style={{ fontSize: 15, fontWeight: 500, wordBreak: "break-word" }}>
                {value || "-"}
            </div>
        </div>
    );

    return (
        <Modal
            title="Event Details"
            open={open}
            onCancel={onClose}
            width={700}
            centered
        >
            <Row gutter={[16, 10]}>

                <Col xs={24} sm={12}>
                    <Item label="Church Name" value={data.user?.name} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Plan" value={data.normalOrShuffeled} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Plan Type" value={data.plan_type} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item
                        label="Last readed Date"
                        value={
                            data.readed
                                ? `${formatDateToDMY(data.readed)} ${formatTime12Hour(data.readed)}`
                                : "-"
                        }
                    />
                </Col>

                <Col xs={24} sm={12}>
                    <Item
                        label="Started Date"
                        value={
                            data.start_date
                                ? `${formatDateToDMY(data.start_date)} ${formatTime12Hour(data.start_date)}`
                                : "-"
                        }
                    />
                </Col>

                <Col xs={24} sm={12}>
                    <Item
                        label="End Date"
                        value={
                            data.end_date
                                ? `${formatDateToDMY(data.end_date)} ${formatTime12Hour(data.end_date)}`
                                : "-"
                        }
                    />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Completed days" value={data.completed_days} />
                </Col>

                <Col xs={24} sm={12}>
                    <Item label="Remaining days" value={data.remaining_days} />
                </Col>
            </Row>
        </Modal>
    );
};

export default ReadingPlanViewModal;